import { _patientUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';
const deletePatient = createAsyncThunk('deletePatient', async (data:any) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  try {
    let url = `${_patientUrls.delete}/${data?._id}`
    let response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },

    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default deletePatient;
